import React, { useState } from "react";
import "./contact.scss";
import { db } from "../../firebase";
export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    db.collection("contacts").add({
      name:name,
      email:email,
      message:message,
    })
    .then(() => {
      alert("Your Message has been submitted I will reply ASAP :-)");
    })
    .catch((error) => {
      alert(error.message);
    });
    setName("");
    setEmail("");
    setMessage("");
  };
  return (
    <div className="contact" id="contact">
      <div className="left">
        <img src="assets/shake.svg" alt="" />
      </div>
      <div className="right">
        <h3>Wanna Collaborate with me on some Project? </h3>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)}/>
          <input type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
          <textarea placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
}
